import { Button, Grid, Typography } from "@mui/material";
import Input from "./Input";
import { Controller, FieldValues, useForm } from "react-hook-form";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export interface LoginFormData {
  username: string;
  password: string;
}

interface LoginFormProps {
  onSubmit: (data: LoginFormData) => void;
  isLoading: boolean;
}

const LoginForm = ({ onSubmit, isLoading }: LoginFormProps) => {
  const { handleSubmit, control } = useForm<LoginFormData>();
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const onSubmitHandler = (data: LoginFormData) => {
    onSubmit(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 12 }}>
          <Controller
            control={control}
            rules={{
              required: "Este campo es requerido",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Debe ser un email válido",
              },
            }}
            name="username"
            render={({ field, fieldState }) => (
              <Input
                label="Usuario"
                name="username"
                required
                field={field}
                error={fieldState.error?.message}
                icon={<PersonIcon />}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <Controller
            control={control}
            rules={{ required: "Este campo es requerido" }}
            name="password"
            render={({ field, fieldState }) => (
              <Input
                label="Contraseña"
                name="password"
                required
                field={field}
                error={fieldState.error?.message}
                icon={showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                type={showPassword ? "text" : "password"}
                onClickIcon={() => setShowPassword(!showPassword)}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
        <Typography
          variant="body2"
          sx={{
            textAlign: "left",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => navigate("/recover-password")}
        >
          Recuperar contraseña
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={isLoading}
          loading={isLoading}
        >
          Ingresar
        </Button>
      </Grid>
    </form>
  );
};

export default LoginForm;
